'use client'

import { Button, Card, Stack, Text, Image } from '@vinted/web-ui'

import { AcceptedOfferWidgetModel, clickEvent } from '@marketplace-web/home/home-page-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

import HomepageBlockLayout from '../Layouts/HomepageBlockLayout'
import TwoColumnsArrangement from '../../common/TwoColumnsArrangement'
import DynamicSpacer from '../../common/DynamicSpacer'
import InformationBreakdown from './InformationBreakdown'

type Props = AcceptedOfferWidgetModel & {
  position: number
  homepageSessionId: string
}

const AcceptedOfferWidget = (props: Props) => {
  const { track } = useTracking()
  const breakpoints = useBreakpoint()

  const trackCtaClick = () => {
    track(
      clickEvent({
        target: 'homepage_accepted_offer_widget_cta',
        targetDetails: JSON.stringify({
          homepage_session_id: props.homepageSessionId,
          item_id: props.item.id,
        }),
      }),
    )
  }

  return (
    <TwoColumnsArrangement
      prefix={<DynamicSpacer phones="XLarge" />}
      suffix={<DynamicSpacer phones="X2Large" />}
    >
      <div className="homepage-accepted-offer-widget-wrapper">
        <Card>
          <HomepageBlockLayout {...props} className="homepage-accepted-offer-widget">
            <Stack direction="column" height="content">
              <Text
                as="h2"
                text={props.title}
                type={breakpoints.phones ? Text.Type.Title : Text.Type.Heading}
              />
              <Text as="p" text={props.subtitle} type={Text.Type.Subtitle} />
            </Stack>

            <div className="homepage-accepted-offer-widget__image homepage-accepted-offer-widget__image--tablets-up">
              <Image
                src={props.item.thumbnailUrl}
                alt={props.item.itemBox?.accessibilityLabel || ''}
                ratio="landscape"
              />
            </div>

            <Stack
              distribution="space-in-between"
              alignment="bottom"
              height="content"
              gap="regular"
              wrap
            >
              <Stack gap="regular" height="content">
                <div className="homepage-accepted-offer-widget__image homepage-accepted-offer-widget__image--phones">
                  <Image
                    src={props.item.thumbnailUrl}
                    ratio="small-portrait"
                    alt={props.item.itemBox?.accessibilityLabel || ''}
                  />
                </div>
                <InformationBreakdown item={props.item} />
              </Stack>

              <div className="u-flexbox u-align-items-flex-end u-fill-height">
                <Button
                  url={props.cta.url}
                  text={props.cta.body}
                  onClick={trackCtaClick}
                  styling={Button.Styling.Filled}
                  inline={breakpoints.desktops}
                  size={Button.Size.Medium}
                />
              </div>
            </Stack>
          </HomepageBlockLayout>
        </Card>
      </div>
    </TwoColumnsArrangement>
  )
}

export default AcceptedOfferWidget
